import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Generate Offers\n          ")
], -1);
const _hoisted_5 = { class: "text-gray-700" };
const _hoisted_6 = { class: "col-span-6 mt-4" };
const _hoisted_7 = /*#__PURE__*/ _createElementVNode("label", {
    for: "offering_to",
    class: "block text-sm font-medium text-gray-700"
}, "Please provide the names of the Candidates you are offering to:", -1);
const _hoisted_8 = ["value", "disabled", "onInput"];
const _hoisted_9 = {
    key: 0,
    class: "absolute text-red-600 top-2 right-2"
};
const _hoisted_10 = {
    key: 1,
    class: "absolute text-red-600 top-2 right-2"
};
const _hoisted_11 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_12 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("p", _hoisted_5, "Approved number of candidates: " + _toDisplayString(_ctx.approvedRoles), 1),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_6, [
                    _hoisted_7,
                    _createTextVNode(),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfOffers + _ctx.cancelledOffers?.length || 0, (n, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "relative"
                        }, [
                            _createElementVNode("input", {
                                id: "offering_to-input",
                                value: _ctx.data.selection?.offering_to[index],
                                type: "text",
                                name: "offering_to",
                                class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200", { 'bg-gray-200 border-none cursor-not-allowed': _ctx.disableForm }]),
                                disabled: _ctx.disableForm || (_ctx.offeringToCopy && (index + 1) <= _ctx.offeringToCopyArray.length),
                                onInput: ($event) => (_ctx.handleNameInput($event, index))
                            }, null, 42, _hoisted_8),
                            _createTextVNode(),
                            (_ctx.data?.offersArray && _ctx.data?.offersArray[index]?.active === 'REJECTED')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Rejected"))
                                : _createCommentVNode("", true),
                            _createTextVNode(),
                            (_ctx.data?.offersArray && _ctx.data?.offersArray[index]?.active === 'CANCELLED')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Cancelled"))
                                : _createCommentVNode("", true)
                        ]));
                    }), 128))
                ])
            ]),
            _createTextVNode(),
            ((_ctx.profile?.userID?.toUpperCase() === _ctx.data.requestedBy?.toUpperCase() || _ctx.profile?.ADMIN || _ctx.profile?.RESOURCING) && (_ctx.data.currentStageName === 'starter.notifyCVsCollected' || _ctx.data.currentStageName === 'starter.notifyCandidateSelected' || _ctx.data.currentStageName === 'starter.complete'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("button", {
                        disabled: _ctx.v$.$invalid,
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Generate Offers\n        ", 8, _hoisted_12)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
